import doRequest from "./index";
import { baseUrl, forgotPassURL, setPassURL, googleMapKey, stripeBaseURL } from "../common/Constant";

const formHeaders = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
  }
};

const GlobalService = {
  // Forgot Password Api
  forgotPassRequest: (lang, user) => {
    const body = new URLSearchParams({ language: lang, user: user }).toString();
    return doRequest("post", `${baseUrl}${forgotPassURL}`, body, formHeaders);
  },
  setPassRequest: (token, serial, pass) => {
    const body = new URLSearchParams({ token, serial, pass }).toString();
    return doRequest("post", `${baseUrl}${setPassURL}`, body, formHeaders);
  },
  // a function to get user menus list
  getMenu: (menu, token) => {
    const body = new URLSearchParams({ menu, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getusermenu.php`,
      body,
      formHeaders
    );
  },
  // a function to get user menus data
  getMenuData: (menu, token) => {
    const body = new URLSearchParams({ menu, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getmenudata.php`,
      body,
      formHeaders
    );
  },
  // a function to update field's data
  saveFieldData: (menu, fieldUdp, token, value) => {
    const body = new URLSearchParams({
      menu,
      name: fieldUdp,
      token,
      value
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/updatevalue.php`,
      body,
      formHeaders
    );
  },
  // a function to get data for Alarm output field
  getOutputSettings: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getoutputsettings.php`,
      body,
      formHeaders
    );
  },
  getInputSettings: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getinputsettings.php`,
      body,
      formHeaders
    );
  },
  getChartsData: (hours, date, token) => {
    const body = new URLSearchParams({ hours, d: date, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getchartv3.php`,
      body,
      formHeaders
    );
  },
  getHomeFieldsData: (dataString, token) => {
    const body = new URLSearchParams({ screen: dataString, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/controllerdata2.php`,
      body,
      formHeaders
    );
  },
  getStatus: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest("post", `${baseUrl}dataout2/getstatus.php`, body, formHeaders);
  },
  resetAlarmField: (name, token, value) => {
    const body = new URLSearchParams({ name, token, value }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/updatevalue.php`,
      body,
      formHeaders
    );
  },
  getHomeModalData: (outputString, token) => {
    const body = new URLSearchParams(outputString);
    body.append("token", token);
    return doRequest(
      "post",
      `${baseUrl}dataout2/getoutputinfo.php`,
      body.toString(),
      formHeaders
    );
  },
  getConsumptionData: (outputString, token) => {
    const body = new URLSearchParams(outputString);
    body.append("token", token);
    return doRequest(
      "post",
      `${baseUrl}dataout2/getconsumption.php`,
      body.toString(),
      formHeaders
    );
  },
  getEventsData: (count, mode, offset, filter, token) => {
    const body = new URLSearchParams({
      count,
      auth: mode,
      offset,
      filter,
      token
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/geteventdata.php`,
      body,
      formHeaders
    );
  },
  getDealers: () => {
    return doRequest(
      "post",
      `${baseUrl}dataout2/getdealers.php`,
      "",
      formHeaders
    );
  },
  getprefillData: (serial, password) => {
    const body = new URLSearchParams({ serial, pass: password }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getprefillname.php`,
      body,
      formHeaders
    );
  },
  usernameSearch: name => {
    const body = new URLSearchParams({ search: name }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/checkalias.php`,
      body,
      formHeaders
    );
  },
  registerUser: (
    address,
    nbeProd,
    countryValue,
    countryName,
    dealerId,
    dealerName,
    email,
    name,
    newPassword,
    userName,
    password,
    languageValue,
    timezoneValue,
    city,
    serialNumber,
    zipCode
  ) => {
    const body = new URLSearchParams({
      address,
      contactTerms: nbeProd,
      country: countryValue,
      countryname: countryName,
      dealerId,
      dealerName,
      email,
      name,
      newpassword: newPassword,
      newusername: userName,
      password,
      selectedlanguage: languageValue,
      timezone: timezoneValue,
      town: city,
      usernumber: serialNumber,
      zip: zipCode
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/registeruser.php`,
      body,
      formHeaders
    );
  },
  // Third-party Google Geocoding API — left as GET, outside our backend's security surface
  getUserLocation: loc => {
    return doRequest(
      "get",
      `https://maps.googleapis.com/maps/api/geocode/json?key=${googleMapKey}&address=${loc}`
    );
  },
  updateUserLocation: (lat, lng, token) => {
    const body = new URLSearchParams({ lat, lng, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/updatelocation.php`,
      body,
      formHeaders
    );
  },
  // Static locale file — left as GET, not a backend API call
  getLang: lng => {
    return doRequest("get", `/locales/${lng}.json`);
  },
  getConfigbackupData: (action, token) => {
    const body = new URLSearchParams({ action, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/configbackup.php`,
      body,
      formHeaders
    );
  },
  pushConfigbackupData: (action, id, token) => {
    const body = new URLSearchParams({
      action,
      blobid: id,
      token
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/configbackup.php`,
      body,
      formHeaders
    );
  },
  editConfigbackupData: (action, id, name, token) => {
    const body = new URLSearchParams({
      action,
      blobid: id,
      name,
      token
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/configbackup.php`,
      body,
      formHeaders
    );
  },
  handoverController: (action, password, serial, token, type) => {
    const body = new URLSearchParams({
      action,
      password,
      serial,
      token,
      type
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/configbackup.php`,
      body,
      formHeaders
    );
  },
  getEmailTickets: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest("post", `${baseUrl}dataout2/gettickets.php`, body, formHeaders);
  },
  getTicketMessages: (id, token) => {
    const body = new URLSearchParams({ ticketid: id, token }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getticketmessages.php`,
      body,
      formHeaders
    );
  },
  sendTicketReply: (msg, id, token) => {
    const body = new URLSearchParams({
      message: msg,
      ticketid: id,
      token
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/savemessage.php`,
      body,
      formHeaders
    );
  },
  logoutUser: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest("post", `${baseUrl}dataout2/logout.php`, body, formHeaders);
  },
  acceptTerms: (accept, type, token) => {
    const params = accept ? { accepted: accept, type, token } : { type, token };
    const body = new URLSearchParams(params).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/acceptterms.php`,
      body,
      formHeaders
    );
  },
  getPaymentLink: (months, lang, token) => {
    const body = new URLSearchParams({
      token,
      language: lang,
      months
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}payment/getpaymentlink.php`,
      body,
      formHeaders
    );
  },
  getPaymentInvoices: token => {
    const body = new URLSearchParams({ token }).toString();
    return doRequest(
      "post",
      `${baseUrl}payment/getpayments.php`,
      body,
      formHeaders
    );
  },
  getAllPayments: (token, start, end) => {
    const body = new URLSearchParams({ token, start, end }).toString();
    return doRequest(
      "post",
      `${baseUrl}payment/getallpayments.php`,
      body,
      formHeaders
    );
  },
  getStripePaymentLink: userInfoURL => {
    const body = new URLSearchParams(userInfoURL);
    return doRequest(
      "post",
      `${stripeBaseURL}skpayment/pay.php`,
      body.toString(),
      formHeaders
    );
  },
  getPaymentExpiryDetails: token => {
    const body = new URLSearchParams({
      forceexpire: false,
      token,
      lang: localStorage.getItem("language")
    }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getoverlaymessage.php`,
      body,
      formHeaders
    );
  },
  // a function to get countries for energy table
  getelCountries: () => {
    return doRequest(
      "post",
      `${baseUrl}dataout2/getelcountries.php`,
      "",
      formHeaders
    );
  },
  // a function to get providers in all countries for energy table
  getelProviders: () => {
    return doRequest(
      "post",
      `${baseUrl}dataout2/getelproviders.php`,
      "",
      formHeaders
    );
  },
  // a function to get values against a provider
  getelValues: providerId => {
    const body = new URLSearchParams({ providerid: providerId }).toString();
    return doRequest(
      "post",
      `${baseUrl}dataout2/getellist.php`,
      body,
      formHeaders
    );
  }
};

export default GlobalService;
